export class Implants{
    percentOfCost:number=0;
    thresholdType:string='NA';
    thresholdAmount?:number;
}